<template>
  <div class="p-efficiency" v-if="efficiency">
    <b-card-text class="eff-text">Production efficiency</b-card-text>
    <b-row>
      <b-col class="is-flex">
        <kuni-eff-info
          v-for="{ key, title } in options"
          :title="title"
          :key="key"
          :value="efficiency[key]"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "ProductionEfficiency",
  props: ["efficiency"],
  data: () => ({
    options: [
      { key: "ore", title: "Ore" },
      { key: "stone", title: "Stone" },
      { key: "cotton", title: "Cotton" },
      { key: "lumber", title: "Lumber" },
    ],
  }),
};
</script>

<style lang="scss">
.p-efficiency {
  padding-top: 16px;
  padding-bottom: 10px;
  .eff-text {
    font-size: 30px;
    font-weight: bold;
  }
}
</style>
